export enum ProductType {
    FTTX = 'FTTX',
    DOCSIS = 'DOCSIS',
}
